import type { ISpecialism } from '../components/interfaces/specialism';
import { getLanguageCode, translateKey } from '../translate';

export function getSpecialismSelectOptions(specialisms: ISpecialism[], addSelectSpecialismPlaceHolder: boolean = true) {
    const options = addSelectSpecialismPlaceHolder
        ? [{ value: '', text: translateKey('common.selectItem', translateKey('service.specialism')) }]
        : [];
    if (getLanguageCode() === 'nl') {
        return options.concat(
            specialisms
                .sort((a: any, b: any) => a.descriptionNL.localeCompare(b.descriptionNL))
                .map((specialism) => ({ value: specialism.code, text: specialism.descriptionNL }))
        );
    } else {
        return options.concat(
            specialisms
                .sort((a: any, b: any) => a.descriptionEN.localeCompare(b.descriptionEN))
                .map((specialism) => ({ value: specialism.code, text: specialism.descriptionEN }))
        );
    }
}
